export default function CTA() {
    return (
        <div>
            CTA
        </div>
    )
}
